"use client";

import { useCookieConsentContext } from "@use-cookie-consent/react";
import Script from "next/script";
import { useEffect, useState } from "react";

export function ConditionalGoogleTagManager() {
    const { consent } = useCookieConsentContext();
    const [shouldLoad, setShouldLoad] = useState(false);
    const gtmId = process.env.NEXT_PUBLIC_GTM_ID;

    useEffect(() => {
        const allowedHosts = [
            "storystreameditor.com",
            "www.storystreameditor.com",
        ];
        if (typeof window !== "undefined") {
            const host = window.location.hostname;
            if (allowedHosts.includes(host)) {
                setShouldLoad(true);
            }
        }
    }, []);

    useEffect(() => {
        if (!gtmId || gtmId === "" || gtmId.startsWith("GTM-XXXX")) {
            // eslint-disable-next-line no-console
            console.warn(
                "[ConditionalGoogleTagManager] No valid NEXT_PUBLIC_GTM_ID set. Google Tag Manager will not be loaded."
            );
        }
    }, [gtmId]);

    if (!consent?.thirdParty || !shouldLoad || !gtmId) {
        return null;
    }

    return (
        <>
            <Script id="gtm-script" strategy="afterInteractive">
                {`
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${gtmId}');
        `}
            </Script>
            <noscript
                dangerouslySetInnerHTML={{
                    __html: `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
                }}
            />
        </>
    );
}
